export const GET_TAGS_CATEGORIES = 'GET_TAGS_CATEGORIES'
export const GET_TAGS_CATEGORY = 'GET_TAGS_CATEGORY'
export const ADD_TAGS_CATEGORY = 'ADD_TAGS_CATEGORY'
export const UPDATE_TAGS_CATEGORY = 'UPDATE_TAGS_CATEGORY'
export const DELETE_TAGS_CATEGORY = 'DELETE_TAGS_CATEGORY'
